'use client';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import {
  clientToken,
  applicationId,
  site,
  env,
  version,
  isProduction,
} from '@/lib/datadog/datadog.env';
import { DATADOG_CONFIG } from '@/lib/datadog/types';

if (isProduction) {
  datadogLogs.init({
    clientToken,
    site,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    trackingConsent: 'granted',
    service: DATADOG_CONFIG.SERVICE_NAME,
    version,
    silentMultipleInit: true,
    env: env,
    forwardConsoleLogs: ['debug', 'error'],
  });

  datadogRum.init({
    applicationId: applicationId,
    clientToken: clientToken,
    site: site,
    //was website changing to www.ikhokha.com
    service: DATADOG_CONFIG.SERVICE_NAME,
    version,
    env,
    sessionSampleRate: 20, // Adjust this value based on your needs
    sessionReplaySampleRate: 0, // Disable session replay sampling
    trackUserInteractions: true, // Enable tracking of user interactions
    trackResources: true, // Enable tracking of resource loads
    trackLongTasks: true, // Enable tracking of long tasks
    defaultPrivacyLevel: 'allow', // Set the default privacy level
  });
}

export function logInfo(message: string, context?: Record<string, unknown>) {
  datadogLogs.logger.info(message, context);
}

export function logError(message: string, context?: Record<string, unknown>) {
  datadogLogs.logger.error(message, context);
}

export function logDebug(message: string, context?: Record<string, unknown>) {
  datadogLogs.logger.debug(message, context);
}
